import React, { useState,useEffect } from "react";
import { IoDocumentOutline } from "react-icons/io5";
import { LuFileUp} from "react-icons/lu";
import LuFilePen from "../../../../assets/images/cms/scheduler/LuFilePen draft.svg";
import DraftContentComparison from "./list/diffComparision";
import ScheduledContentDashboard from "./list/queueList";
import { useDispatch } from "react-redux";
import PublishedContent from "./list/publishedList";
import { getScheduledQueueList, getPublishedList} from "../../../../../store/actions/cms/scheduler.js";


const HeaderTab = (props) => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState(() => {
    return localStorage?.setItem("activeContentTab", 'draft') ||'draft'
  });
  const [draftLength, setDraftLength] = useState('0');

  const renderContent = () => {
    switch (activeTab) {
      case "queue":
        return <ScheduledContentDashboard setQueueLength={props.setQueueLength} queueCurrentPage={props.queueCurrentPage} setQueueCurrentPage={props.setQueueCurrentPage}/>;
      case "draft":
        return <DraftContentComparison currentPage={props.currentPage} setCurrentPage={props.setCurrentPage} setDraftLength={setDraftLength}/>;
      case "published":
        return <PublishedContent setPublishedLength={props.setPublishedLength} publishedCurrentPage={props.publishedCurrentPage} setPublishedCurrentPage={props.setPublishedCurrentPage}/>;
      default:
        return null;
    }
  };

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
    localStorage?.setItem("activeContentTab", tabName);
  };
  
  useEffect(() => {
    if(activeTab){
      props.setPublishedCurrentPage(1)
      props.setCurrentPage(1)
      props.setQueueCurrentPage(1)
      if(activeTab === 'queue') dispatch(getScheduledQueueList({page:1,page_size:12}));
      if(activeTab === 'published') dispatch(getPublishedList({page:1,page_size:12}));
    }
  }, [activeTab])
  

  return (
   <>
    <div className="content_tab_section">
      <div className="content_tab_container">
      <button
        onClick={() => handleTabClick("queue")}
        className={`content_tab ${activeTab === "queue" ? "active_tab" : ""}`}
      >
          <IoDocumentOutline size={18} className=""/>
          In Queue
          <div className={`content_tab_length ${activeTab === "queue" ? "active_tab_length" : ""}`}>{props.queueLength}</div>
        </button>
        <button
          onClick={() => handleTabClick("draft")}
          className={`content_tab ${activeTab === "draft" ? "active_tab" : ""}`}
        >
          <img src={LuFilePen} />
          {/* <LuFilePen size={18} className=""/> */}
          Drafts
          <div className={`content_tab_length ${activeTab === "draft" ? "active_tab_length" : ""}`}>{draftLength}</div>
        </button>
        <button
          onClick={() => handleTabClick("published")}
          className={`content_tab ${activeTab === "published" ? "active_tab" : ""}`}
        >
          <LuFileUp size={18} className=""/>
          Published
          <div className={`content_tab_length ${activeTab === "published" ? "active_tab_length" : ""}`}>{props.publishedLength}</div>
        </button>
      </div>
    </div>
    {/* <div className="content_tab_body"> */}
    <div className="">
        {renderContent()}
    </div>
   </>
  );
};

export default HeaderTab;